import { useMutation } from '@tanstack/react-query';

import QuestionsService from '../../services/QuestionsService';

enum QUESTION_QUERY_KEYS {
  COMPLETE_QUESTIONNAIRE = 'complete-questionnaire',
}

const questionsService = new QuestionsService();

export const useCompleteQuestionnaireMutation = () => {
  const { mutateAsync, isPending } = useMutation<void, Error, string>({
    mutationKey: [QUESTION_QUERY_KEYS.COMPLETE_QUESTIONNAIRE],
    mutationFn: (appointmentId: string) => questionsService.completeQuestionnaire(appointmentId),
  });

  return {
    completeQuestionnaire: mutateAsync,
    isPending,
  };
};
